var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90283 23H27.5028V24.5C27.5028 25.5609 27.0814 26.5783 26.3312 27.3284C25.5811 28.0786 24.5637 28.5 23.5028 28.5H8.90283C7.84197 28.5 6.82455 28.0786 6.0744 27.3284C5.32426 26.5783 4.90283 25.5609 4.90283 24.5V23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8028 16.9002H27.4028C27.8051 16.8868 28.206 16.9545 28.5816 17.0992C28.9572 17.244 29.2998 17.4628 29.5891 17.7428C29.8783 18.0227 30.1082 18.358 30.2652 18.7286C30.4222 19.0993 30.503 19.4977 30.5028 19.9002C30.5028 20.7224 30.1762 21.5109 29.5948 22.0923C29.0134 22.6736 28.225 23.0002 27.4028 23.0002H5.00276C4.60024 23.0005 4.20181 22.9197 3.83116 22.7627C3.46051 22.6057 3.12522 22.3757 2.84529 22.0865C2.56537 21.7972 2.34651 21.4546 2.20177 21.079C2.05702 20.7034 1.98935 20.3025 2.00276 19.9002C1.98879 19.5025 2.05686 19.1062 2.20268 18.7359C2.3485 18.3656 2.56898 18.0292 2.85039 17.7478C3.1318 17.4664 3.4681 17.246 3.8384 17.1001C4.20869 16.9543 4.60503 16.8863 5.00276 16.9002H13.8028",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5026 14.8999C30.4951 15.4274 30.2795 15.9307 29.9027 16.2999C29.7273 16.4962 29.5111 16.6516 29.2692 16.7553C29.0273 16.859 28.7657 16.9083 28.5026 16.8999H23.3027L19.9027 20.7999L16.5026 16.8999H3.90266C3.6445 16.9003 3.38897 16.848 3.15168 16.7463C2.91439 16.6447 2.7003 16.4957 2.5225 16.3085C2.3447 16.1214 2.20691 15.8999 2.11753 15.6578C2.02815 15.4156 1.98905 15.1577 2.00263 14.8999C1.98905 14.6421 2.02815 14.3842 2.11753 14.1421C2.20691 13.8999 2.3447 13.6785 2.5225 13.4913C2.7003 13.3041 2.91439 13.1552 3.15168 13.0535C3.38897 12.9518 3.6445 12.8995 3.90266 12.8999H28.5026C29.0331 12.8999 29.5418 13.1106 29.9169 13.4857C30.292 13.8608 30.5026 14.3695 30.5026 14.8999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5028 4H19.0028C21.2837 4 23.4711 4.90606 25.0839 6.51888C26.6967 8.13169 27.6028 10.3191 27.6028 12.6H4.90283C4.90283 10.3191 5.80888 8.13169 7.42169 6.51888C9.0345 4.90606 11.2219 4 13.5028 4Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6025 8.5L11.8026 9.8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4028 8L22.7028 9.39999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4028 8.59981L16.8028 7.2998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.a39e1778019beb0d587335a5b4b1ac39.svg";
export { ForwardRef as ReactComponent };